import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
  period: '3MONTH' | 'MONTH' | 'YEAR' | 'CUSTOM';
  customStart?: string;
  customEnd?: string;
}

const PeriodLabel: React.FC<Props> = ({ period, customStart, customEnd }) => {
  const { t } = useTranslation();
  const today = dayjs();
  let start: dayjs.Dayjs;
  let end: dayjs.Dayjs;

  if (period === '3MONTH') {
    start = today.subtract(3, 'month');
    end = today;
  } else if (period === 'MONTH') {
    start = today.subtract(1, 'month');
    end = today;
  } else if (period === 'YEAR') {
    start = today.subtract(1, 'year');
    end = today;
  } else {
    start = customStart ? dayjs(customStart) : today;
    end = customEnd ? dayjs(customEnd) : today;
  }

  return (
    <span className="fs-5">
      <strong>{t('ChartsAnalitics.mice_activity_pie_chart.from')}</strong> {start.format('YYYY-MM-DD')}{' '}
      <strong>{t('ChartsAnalitics.mice_activity_pie_chart.to')}</strong> {end.format('YYYY-MM-DD')}
    </span>
  );
};

export default PeriodLabel;
